import { library, dom } from "@fortawesome/fontawesome-svg-core";

// add all icons to be used in the app here, to reduce size
import { faDotCircle, faSquare, faCalendar, faFrown } from "@fortawesome/free-regular-svg-icons";
import { faGoogle, faFacebook } from "@fortawesome/free-brands-svg-icons";
import {
  faSignInAlt,
  faUser,
  faEnvelope,
  faBars,
  faLock,
  faClipboardCheck,
  faExclamationTriangle,
  faTimesCircle,
  faSignOutAlt,
  faInfoCircle,
  faCheckCircle,
  faGift,
  faUserCircle,
  faThLarge,
  faChartPie,
  faMale,
  faFemale,
  faPencilAlt,
  faGlobeAmericas,
  faLanguage,
  faChessRook,
  faSlidersH,
  faChild,
  faEllipsisH,
  faCalendarPlus,
  faPlusCircle,
  faHiking,
  faWalking,
  faCaretDown,
  faSave,
  faInfo,
  faPlus,
  faChevronLeft,
  faChevronRight,
  faEllipsisV,
  faTrashAlt,
  faTimes,
  faCopy,
  faCheckSquare,
  faUserPlus,
  faUserCheck,
  faUserMinus,
  faUserSlash,
  faUserFriends,
  faPaperPlane,
  faCalendarDay,
  faGifts,
  faLink,
  faUnlink,
  faShoppingCart,
  faImage,
  faMoneyBillWave,
  faCoins,
  faHandHolding,
  faBan,
  faExclamationCircle,
  faList,
  faShareAlt,
  faClone,
  faCircle,
  faQuestionCircle,
  faMinus,
  faBaby,
  faBlind,
  faMagic} from "@fortawesome/free-solid-svg-icons";

library.add(
  faSignInAlt,
  faUser,
  faEnvelope,
  faBars,
  faLock,
  faClipboardCheck,
  faExclamationTriangle,
  faTimesCircle,
  faSignOutAlt,
  faInfoCircle,
  faCheckCircle,
  faGift,
  faGoogle,
  faUserCircle,
  faThLarge,
  faChartPie,
  faMale,
  faFemale,
  faPencilAlt,
  faGlobeAmericas,
  faLanguage,
  faChessRook,
  faSlidersH,
  faChild,
  faEllipsisH,
  faCalendarPlus,
  faPlusCircle,
  faHiking,
  faWalking,
  faCaretDown,
  faSave,
  faInfo,
  faPlus,
  faDotCircle,
  faCircle,
  faChevronLeft,
  faChevronRight,
  faEllipsisV,
  faTrashAlt,
  faTimes,
  faCopy,
  faSquare,
  faCheckSquare,
  faCalendar,
  faUserPlus,
  faUserCheck,
  faUserMinus,
  faUserSlash,
  faUserFriends,
  faPaperPlane,
  faCalendarDay,
  faGifts,
  faLink,
  faUnlink,
  faShoppingCart,
  faImage,
  faMoneyBillWave,
  faCoins,
  faHandHolding,
  faBan,
  faFrown,
  faImage,
  faExclamationCircle,
  faList,
  faShareAlt,
  faClone,
  faQuestionCircle,
  faFacebook,
  faMinus,
  faBaby,
  faBlind,
  faMagic) ;
dom.watch();
